import { IconName } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppointmentMode } from '__generated__/globalTypes';
import { tracking } from 'App/Tracking';
import { AddToCalendar } from 'Book/shared/components/AddToCalendar';
import { appointmentModeMap } from 'Book/shared/utils';

import {
  AppointmentIcon,
  StyledAppointment,
  StyledAppointmentType,
} from '../../styles';
import type { SessionDetailsProps } from '../../types';

export default ({
  appointment,
  counsellor,
  dates,
  type,
  showAddToCalendar,
}: SessionDetailsProps) => {
  const { t } = useTranslation('book');

  const appointmentType =
    typeof type === 'object' && type.__typename === 'BookableService'
      ? appointment?.type || AppointmentMode.PHONE
      : undefined;

  return (
    <StyledAppointment className="appointment">
      {(appointmentType || appointment?.url) && (
        <StyledAppointmentType>
          <AppointmentIcon
            iconName={
              appointmentType === AppointmentMode.PHONE
                ? IconName.Phone
                : IconName.VideoFull
            }
          />
          {appointmentType ? (
            t(`appointment_type.${appointmentModeMap[appointmentType]}`)
          ) : (
            <a
              href={appointment?.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                tracking.track('talk-event-meeting-link-selected', {
                  linkType: appointment?.platform,
                })
              }
            >
              {t('sessionDetails.appointment.cta')}
            </a>
          )}
        </StyledAppointmentType>
      )}
      {showAddToCalendar && dates?.startDate && dates?.endDateTime && (
        <AddToCalendar
          counsellorName={
            counsellor?.name ||
            t('service.form.confirmDetails.counsellorName.fallback.default')
          }
          dates={{
            beginsAt: dates.startDate,
            endsAt: dates.endDateTime,
            timezone: dates.timezone,
          }}
          details={{
            url: appointment?.url,
            id: appointment?.session?.externalRef,
            password: appointment?.session?.password,
          }}
          type={appointmentType || appointment?.platform}
        />
      )}
    </StyledAppointment>
  );
};
